import { useId, useState } from 'react'
import { Lock, Globe, ChevronDown } from 'lucide-react'
import flagSrc from '@/assets/usvi-flag.svg'

/**
 * Slim banner modeled on the USWDS "official government site" pattern,
 * but honest: VICE is not an official government site. We signal the
 * security posture (HTTPS, USVI-focused) without claiming federal status.
 */
export function GovBanner() {
  const [open, setOpen] = useState(false)
  const panelId = useId()

  return (
    <div className="bg-neutral-100 border-b border-neutral-200 text-neutral-700 text-[13px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center gap-2 py-1.5 flex-wrap">
          <img src={flagSrc} alt="" className="h-3.5 w-auto flex-shrink-0" aria-hidden="true" />
          <span className="leading-tight">
            A secure web application for U.S. Virgin Islands commercial operations.
          </span>
          <button
            type="button"
            onClick={() => setOpen(!open)}
            aria-expanded={open}
            aria-controls={panelId}
            className="inline-flex items-center gap-1 text-secondary hover:text-primary focus-visible:outline-2 focus-visible:outline-accent-turquoise focus-visible:outline-offset-2 rounded px-1 font-medium"
          >
            Here&apos;s how you know
            <ChevronDown
              size={14}
              className={`transition-transform ${open ? 'rotate-180' : ''}`}
              aria-hidden="true"
            />
          </button>
        </div>

        {open && (
          <div id={panelId} className="pb-4 pt-2 grid gap-4 sm:grid-cols-2">
            <div className="flex gap-3">
              <Globe
                size={28}
                className="flex-shrink-0 text-secondary mt-0.5"
                aria-hidden="true"
              />
              <div>
                <p className="font-semibold text-neutral-900">
                  VICE was built by{' '}
                  <a
                    href="https://metaphase.tech"
                    target="_blank"
                    rel="noreferrer"
                    className="text-accent-sunset font-bold hover:text-accent-coral focus-visible:outline-2 focus-visible:outline-accent-turquoise focus-visible:outline-offset-2 rounded"
                  >
                    MetaPhase
                  </a>
                </p>
                <p className="text-neutral-500 mt-0.5 leading-relaxed">
                  A private sector tool for U.S. Virgin Islands entry data review and transmission. This is
                  not an official U.S. government site.
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <Lock
                size={28}
                className="flex-shrink-0 text-secondary mt-0.5"
                aria-hidden="true"
              />
              <div>
                <p className="font-semibold text-neutral-900">
                  Secure <code className="font-mono text-[12px]">https://</code> connection
                </p>
                <p className="text-neutral-500 mt-0.5 leading-relaxed">
                  A lock icon (🔒) or <code className="font-mono text-[12px]">https://</code>{' '}
                  means you&apos;ve connected securely. Data is protected with TLS in transit and
                  encrypted at rest.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
